var _circle, _path, _path2, _path3, _circle2, _path4, _circle3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResultsFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 120,
    viewBox: "0 0 138 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 41.1855,
    r: 39,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7537 14.693C30.1066 14.693 29.5819 14.1685 29.5819 13.5212C29.5819 12.7437 28.9493 12.1112 28.1719 12.1112C27.5248 12.1112 27 11.5866 27 10.9393C27 10.292 27.5248 9.76742 28.1719 9.76742C28.9493 9.76742 29.5819 9.13508 29.5819 8.35742C29.5819 7.71008 30.1066 7.18555 30.7537 7.18555C31.4009 7.18555 31.9256 7.71008 31.9256 8.35742C31.9256 9.13484 32.5582 9.76742 33.3356 9.76742C33.9827 9.76742 34.5075 10.292 34.5075 10.9393C34.5075 11.5866 33.9827 12.1112 33.3356 12.1112C32.5582 12.1112 31.9256 12.7435 31.9256 13.5212C31.9256 14.1683 31.4011 14.693 30.7537 14.693Z",
    fill: "#2940E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.1855C22.4828 26.1855 22.0634 25.7663 22.0634 25.249C22.0634 24.6277 21.5579 24.1221 20.9366 24.1221C20.4194 24.1221 20 23.7029 20 23.1855C20 22.6682 20.4194 22.249 20.9366 22.249C21.5579 22.249 22.0634 21.7436 22.0634 21.1221C22.0634 20.6048 22.4828 20.1855 23 20.1855C23.5172 20.1855 23.9366 20.6048 23.9366 21.1221C23.9366 21.7434 24.4421 22.249 25.0634 22.249C25.5806 22.249 26 22.6682 26 23.1855C26 23.7029 25.5806 24.1221 25.0634 24.1221C24.4421 24.1221 23.9366 24.6275 23.9366 25.249C23.9366 25.7662 23.5174 26.1855 23 26.1855Z",
    fill: "#2940E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.749 78.6832C108.438 78.6832 108.14 78.5599 107.92 78.3399L105.343 75.7629C104.886 75.3054 104.886 74.5634 105.343 74.1059L107.92 71.5289C108.14 71.3091 108.438 71.1855 108.749 71.1855C109.06 71.1855 109.358 71.3088 109.578 71.5289L112.155 74.1059C112.612 74.5634 112.612 75.3054 112.155 75.7629L109.578 78.3399C109.358 78.5599 109.06 78.6832 108.749 78.6832ZM107.829 74.9344L108.749 75.8541L109.669 74.9344L108.749 74.0147L107.829 74.9344Z",
    fill: "#2940E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2037,
    cy: 56.3887,
    r: 13,
    transform: "rotate(-16.8075 16.2037 56.3887)",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 48.6666C11.8859 49.3353 10.4907 50.7687 9.79455 53.003C9.47918 54.0123 10.002 55.0948 10.9995 55.4791L12.3594 55.9824C12.7308 56.1313 13.1948 56.1544 13.5837 56.0369C13.4263 56.7047 13.4366 57.3871 13.6535 58.1051L13.7619 58.4641C13.9065 58.9427 14.2215 59.3372 14.6201 59.5759C14.2832 60.2979 14.2308 61.0972 14.4658 61.875C14.9899 63.6101 16.7816 64.5705 18.5167 64.0464C20.2218 63.5313 21.2122 61.7306 20.6881 59.9955C20.4532 59.2177 19.9371 58.5901 19.2569 58.1753C19.4448 57.8248 19.5068 57.3816 19.4193 56.9837C20.1033 56.2221 21.8483 54.6504 21.0441 51.988C20.1947 49.176 16.8218 47.8444 14.0996 48.6666ZM18.083 62.6105C17.1556 62.8906 16.1818 62.3686 15.9017 61.4413C15.6306 60.5438 16.1435 59.5401 17.0709 59.26C17.9684 58.9889 18.9811 59.5318 19.2522 60.4292C19.5323 61.3566 18.9804 62.3394 18.083 62.6105ZM17.8388 56.9388L17.9201 57.208C17.9924 57.4474 17.8462 57.72 17.6069 57.7923L15.7821 58.3435C15.5428 58.4158 15.2701 58.2697 15.1978 58.0303L15.0894 57.6714C14.6647 56.2653 15.54 55.3807 16.2122 54.688C16.8127 54.0822 17.1502 53.6865 16.9966 53.1779C16.7887 52.4899 15.7856 52.3032 15.0677 52.5201C14.1702 52.7912 13.857 53.3754 13.5146 54.295C13.3893 54.5287 13.1082 54.6789 12.8745 54.5536L11.5237 54.0803C11.2691 53.9939 11.1488 53.7038 11.2052 53.4583C11.7468 51.793 12.6786 50.6628 14.5333 50.1026C16.4778 49.5152 19.0028 50.4174 19.6082 52.4217C20.4034 55.0542 17.5496 55.9815 17.8388 56.9388Z",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.999,
    cy: 15.1847,
    r: 13,
    transform: "rotate(10.684 121.999 15.1847)",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.79 7.38123C121.333 6.91775 119.545 7.62986 117.944 9.20411C117.672 9.47064 117.646 9.94285 117.943 10.2215L119.073 11.484C119.333 11.7876 119.806 11.8131 120.109 11.5524C121.056 10.7453 121.744 10.3026 122.942 10.5285C123.894 10.7081 124.951 11.5117 124.777 12.433C124.644 13.1393 123.996 13.367 122.977 13.7152C121.755 14.1208 120.167 14.6162 119.808 16.5202L119.756 16.7965C119.675 17.2264 119.955 17.5973 120.354 17.6726L122.595 18.0955C122.995 18.1708 123.39 17.9275 123.471 17.4975L123.5 17.344C123.75 16.0236 127.6 16.6863 128.272 13.1242C128.776 10.4525 126.369 7.86788 123.79 7.38123ZM121.316 18.8082C120.119 18.5822 118.987 19.3546 118.767 20.5215C118.547 21.6884 119.319 22.82 120.517 23.0459C121.684 23.2661 122.815 22.4937 123.035 21.3268C123.255 20.1599 122.483 19.0283 121.316 18.8082Z",
    fill: "#3794FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M89.152 23.0341C78.9816 12.8636 62.4076 12.8636 52.2372 23.0341C42.0668 33.2045 42.0668 49.7785 52.2372 59.9489C62.4076 70.1193 78.9816 70.1193 89.152 59.9489C99.3224 49.7785 99.3224 33.2798 89.152 23.0341Z",
    fill: "#0092E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M52.1611 23.0341C49.9763 25.2188 48.2436 27.7802 46.9629 30.417C48.2436 33.3551 50.0517 36.0672 52.3871 38.4027C62.5575 48.5731 79.1315 48.5731 89.3019 38.4027C91.4867 36.2179 93.2194 33.6565 94.5001 31.0197C93.2194 28.0816 91.4113 25.3695 89.0759 23.0341C78.9055 12.8636 62.4068 12.8636 52.1611 23.0341Z",
    fill: "#0092E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M84.9329 27.2534C81.4674 23.7879 75.8926 23.7879 72.5024 27.2534C69.037 30.7189 69.037 36.2938 72.5024 39.6839C75.9679 43.1494 81.5428 43.1494 84.9329 39.6839C88.3984 36.2938 88.3984 30.7189 84.9329 27.2534Z",
    fill: "#9DE9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M69.4138 48.9499C67.6811 47.2172 64.8936 47.2172 63.1609 48.9499C61.4281 50.6827 61.4281 53.4701 63.1609 55.2029C64.8936 56.9356 67.6811 56.9356 69.4138 55.2029C71.1465 53.4701 71.1465 50.6827 69.4138 48.9499Z",
    fill: "#9DE9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3951 76.5987L35.5871 74.7907C34.6077 73.8113 34.6077 72.1539 35.5871 71.1745L48.3942 58.3673C49.3736 57.388 51.031 57.388 52.0104 58.3673L53.8185 60.1754C54.7978 61.1548 54.7978 62.8122 53.8185 63.7916L41.0113 76.5987C40.0319 77.5781 38.3745 77.5781 37.3951 76.5987Z",
    fill: "#110C22"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4121 20.7739C79.961 9.32277 61.3529 9.32277 49.9018 20.7739C38.4507 32.225 38.4507 50.8331 49.9018 62.2842C61.3529 73.7353 79.961 73.7353 91.4121 62.2842C102.863 50.8331 102.863 32.225 91.4121 20.7739ZM54.7233 57.4627C45.909 48.6483 45.909 34.3344 54.7233 25.5201C63.5377 16.7057 77.8516 16.7057 86.6659 25.5201C95.4803 34.3344 95.4803 48.6483 86.6659 57.4627C77.8516 66.277 63.5377 66.277 54.7233 57.4627Z",
    fill: "#111842"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8081 94.3784C15.3973 91.9676 15.3973 88.0501 17.8081 85.6394L36.7175 66.7299C39.1283 64.3192 43.0457 64.3192 45.4565 66.7299C47.8673 69.1407 47.8673 73.0582 45.4565 75.469L26.5471 94.3784C24.1363 96.7891 20.2188 96.7891 17.8081 94.3784Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 37.6505,
    y1: 17.96,
    x2: 117.743,
    y2: 49.5601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 5.42055,
    y1: 48.6469,
    x2: 32.1179,
    y2: 59.1803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 111.216,
    y1: 7.44288,
    x2: 137.914,
    y2: 17.9763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92BEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 16.0099,
    y1: 80.5467,
    x2: 47.2563,
    y2: 80.5467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4104,
    stopColor: "#1D4DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0F38C1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsFound);
export default __webpack_public_path__ + "static/media/noResultsFound.b2432b56.svg";
export { ForwardRef as ReactComponent };